module.exports = __webpack_public_path__ + "img/mu.e8ee9ad0.svg";